import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './_guards/auth.guard';

import { HomeComponent } from './components/home/home.component';
import { SidebarMenuComponent } from './components/sidebar-menu/sidebar-menu.component';
import { MainHeaderComponent } from './components/main-header/main-header.component';
import { LoginPageComponent } from './components/login-page/login-page.component';
import { IngredientsComponent } from './components/ingredient/ingredients/ingredients.component';
import { IngredientsBulkComponent } from './components/ingredient/ingredients-bulk/ingredients-bulk.component';
import { IngredientComponent } from './components/ingredient/ingredient/ingredient.component';
import { IngredientsExportComponent } from "./components/ingredient/ingredients-export/ingredients-export.component";
import { AdminComponent } from './components/admin/admin.component';
import { CategoriesComponent } from './components/category/categories/categories.component';
import { MediaSelectorComponent } from './components/media-selector/media-selector.component';
import { TonalitiesComponent } from './components/tonality/tonalities/tonalities.component';
import { ColorShadeComponent } from './components/color-shade/color-shade/color-shade.component';
import { PigmentComponent } from './components/pigment/pigment/pigment.component';
import { IngredientAddEdit } from './components/ingredient/ingredient-add-edit.component';
import { UsersComponent } from "./components/user/users/users.component";
import { UserAddEditComponent } from './components/user/user-add-edit/user-add-edit.component';
import { NewsComponent } from './components/news/news/news.component';
import { NewsAddEditComponent } from './components/news/news-add-edit/news-add-edit.component';
import { CompaniesComponent } from './components/company/companies/companies.component';
import { CompaniesAddEditComponent } from './components/company/companies-add-edit/companies-add-edit.component';
import { CompaniesBulkComponent } from './components/company/companies-bulk/companies-bulk.component';
import { ImageComponent } from './components/media/image/image.component';
import { DocumentComponent } from './components/media/document/document/document.component';
import { DocumentSelectorComponent } from './components/media/document/document-selector/document-selector.component';
import { AddEditCategoryComponent } from "./components/category/add-edit-category.component";
import { QuotationHistoryComponent } from './components/quotation/quotation-history/quotation-history.component';
import { QuotationHistoryListComponent } from "./components/quotation/quotation-history-list/quotation-history-list.component";
import { QuotationHistorySingleComponent } from "./components/quotation/quotation-history-single/quotation-history-single.component";
import { AdminlistComponent } from "./components/adminlist/adminlist/adminlist.component"; 
import { AdminlistAddEditComponent } from "./components/adminlist/adminlist-add-edit/adminlist-add-edit.component"; 

const appRoutes: Routes = [
  {path: '', component: HomeComponent, canActivate: [AuthGuard]},

  {path: 'product', component: IngredientsComponent, canActivate: [AuthGuard]},
  {path: 'product/add', component: IngredientAddEdit, canActivate: [AuthGuard]},
  {path: 'product/bulk-add', component: IngredientsBulkComponent, canActivate: [AuthGuard]},
  {path: 'product/export', component: IngredientsExportComponent, canActivate: [AuthGuard]},
  {path: 'product/:id/edit', component: IngredientAddEdit, canActivate: [AuthGuard]},
  {path: 'product/:id', component: IngredientComponent, canActivate: [AuthGuard]},

  {path: 'category', component: CategoriesComponent, canActivate: [AuthGuard]},
  {path: 'category/add', component: AddEditCategoryComponent, canActivate: [AuthGuard]},
  {path: 'category/:id/edit', component: AddEditCategoryComponent, canActivate: [AuthGuard]},

  {path: 'user', component: UsersComponent, canActivate: [AuthGuard]},
  {path: 'user/add', component: UserAddEditComponent, canActivate: [AuthGuard]},
  {path: 'user/:id/edit', component: UserAddEditComponent, canActivate: [AuthGuard]},

  {path: "adminlist", component: AdminlistComponent, canActivate: [AuthGuard]},
  {path: 'adminlist/add', component: AdminlistAddEditComponent, canActivate: [AuthGuard]},
  {path: 'adminlist/:id/edit', component: AdminlistAddEditComponent, canActivate: [AuthGuard]},

  {path: 'tonality', component: TonalitiesComponent, canActivate: [AuthGuard]},
  {path: 'color-shade', component: ColorShadeComponent, canActivate: [AuthGuard]},
  {path: 'pigment', component: PigmentComponent, canActivate: [AuthGuard]},

  {path: 'media/image', component: ImageComponent, canActivate: [AuthGuard]},
  {path: 'media/document', component: DocumentComponent, canActivate: [AuthGuard]},

  {path: 'news', component: NewsComponent, canActivate: [AuthGuard]},
  {path: 'news/add', component: NewsAddEditComponent, canActivate: [AuthGuard]},
  {path: 'news/:id/edit', component: NewsAddEditComponent, canActivate: [AuthGuard]},

  {path: 'company', component: CompaniesComponent, canActivate: [AuthGuard]},
  {path: 'company/add', component: CompaniesAddEditComponent, canActivate: [AuthGuard]},
  {path: 'company/:id/edit', component: CompaniesAddEditComponent, canActivate: [AuthGuard]},
  {path: 'company/bulk-add', component: CompaniesBulkComponent, canActivate: [AuthGuard]},

  {path: 'quotation-history', component: QuotationHistoryComponent, canActivate: [AuthGuard]},
  {path: 'quotation-history/:id', component: QuotationHistoryComponent, canActivate: [AuthGuard]},
  {path: 'quotation-history/:id/:comp_key', component: QuotationHistoryListComponent, canActivate: [AuthGuard]},
  {path: 'quotation-history/:id/:comp_key/:quote_key/view', component: QuotationHistorySingleComponent, canActivate: [AuthGuard]},
  {path: 'quotation-history/:id/:comp_key/:print_key/print', component: QuotationHistorySingleComponent, canActivate: [AuthGuard]},
]

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [ 
    RouterModule 
  ],
  declarations: []
})
export class AppRoutingModule { }


// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/app-routing.module.ts